import { Component, inject, input } from '@angular/core';
import { Components } from '../../../components';
import { RdsFooterModule } from '@rds/angular-components';
import { Router } from '@angular/router';

@Component({
  selector: 'inexp-sitemap-section',
  imports: [RdsFooterModule],
  templateUrl: './sitemap-section.component.html',
  styleUrl: './sitemap-section.component.scss'
})
export class SitemapSectionComponent {
  router = inject(Router);
  _editable = input<string>();
  _uid = input<string>();
  component = input<string>();
  navigation = input<any>();
  title = input<string>();
  
  components = Components;

  navigate(isExternalLink: boolean, link: string) {
    if(!isExternalLink) {
      this.router.navigate([link]);
    } else {
      window.open(link, '_blank');
    }
  }

  onItemClick(item: any) {
    if(item.onclick) {
      item.onclick();
    }
    this.navigate(item.isExternal, item.link);
    window.scrollTo(0, 0);
  }
}
